import React from 'react';
import './Otp.css'


import Message from '../Assets/Videos/Message0001-0100.webm'
import OTPInput from '../Components/Layout/OtpInput';
import Btn from '../Components/Common/Btn';

const Otp = () => {

    const handleVerify = (code) => {
        console.log("OTP Completed: ", code);
        if(code === '1234') {
            window.location.href = '/home';
        }
    };

    return ( 
        <main className='OtpMain'>
        <div className='Otp'>
            <div className='LoginHeader'>
                                <div className='IconAnim'>
                                    <video className='LoginIcon' muted autoPlay src={Message}></video>
                                </div>
            
                                <p className='LoginTitle'>
                                    Check your mail
                                </p>
                                <p className='LoginSub'>
                                A One-Time-Pin was sent to your email address
                                </p>
                            </div>

            <OTPInput length={4} onComplete={handleVerify} />
            
            <p style={{marginTop: '30px', color: '#666'}}>
                Didn't get a code? <span style={{color: '#21FF55'}}>Resend</span>
            </p>
        </div>

        <Btn BtnStyle="LoginBtn" BtnText="Submit" BtnPath='/home'/>
        </main>
     );
}
 
export default Otp;